import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue'
import DashboardNoSpacingLayout from '../components/Dashboard/Layout/DashboardNoSpacingLayout.vue'
// GeneralViews
import NotFound from '../components/GeneralViews/NotFoundPage.vue'
// Dashboard pages
import Overview from 'src/components/Dashboard/Views/Dashboard/Overview.vue'
import Stats from 'src/components/Dashboard/Views/Dashboard/Stats.vue'

// Ordering Management
import OrderingManagement from 'src/components/Dashboard/Views/OrderingManagement/OrderingManagement.vue'

// Customers
import Customers from 'src/components/Dashboard/Views/Customers/Customers.vue'
import CustomerView from 'src/components/Dashboard/Views/Customers/CustomerView.vue'

// InfoPages
import InfoPages from 'src/components/Dashboard/Views/InfoPages/InfoPages.vue'

// Orders
import Orders from 'src/components/Dashboard/Views/Orders/Orders.vue'
// import OrderView from 'src/components/Dashboard/Views/Orders/OrderView.vue'
import OrderEdit from 'src/components/Dashboard/Views/Orders/OrderEdit.vue'

// Products
import Products from 'src/components/Dashboard/Views/Products/Products.vue'
// import ProductAdd from 'src/components/Dashboard/Views/Products/ProductAdd.vue'
// import ProductEdit from 'src/components/Dashboard/Views/Products/ProductEdit.vue'

// Product Options
import ProductOptions from 'src/components/Dashboard/Views/Settings/Tabs/ProductOptions.vue'

// Categories
import Categories from 'src/components/Dashboard/Views/Categories/Categories.vue'
import CategoryAdd from 'src/components/Dashboard/Views/Categories/CategoryAdd.vue'
import CategoryEdit from 'src/components/Dashboard/Views/Categories/CategoryEdit.vue'

// Marketing
// -- campaigns
import Campaigns from 'src/components/Dashboard/Views/Marketing/Campaigns/Campaigns.vue'
import CampaignAdd from 'src/components/Dashboard/Views/Marketing/Campaigns/CampaignAdd.vue'
import CampaignEdit from 'src/components/Dashboard/Views/Marketing/Campaigns/CampaignEdit.vue'
// -- offers
import Offers from 'src/components/Dashboard/Views/Marketing/Offers/Offers.vue'
import OffersEdit from 'src/components/Dashboard/Views/Marketing/Offers/OffersEdit.vue'
import OffersAdd from 'src/components/Dashboard/Views/Marketing/Offers/OffersAdd.vue'

// Reward Points
import RewardProgramEdit from 'src/components/Dashboard/Views/RewardProgram/RewardProgramEdit.vue'

// Reports
import Reports from 'src/components/Dashboard/Views/Reports/Reports.vue'
import ReportsCustomerDetails from 'src/components/Dashboard/Views/Reports/ReportsCustomerDetails.vue'

// Settings
import Settings from 'src/components/Dashboard/Views/Settings/Settings.vue'
import Users from 'src/components/Dashboard/Views/Settings/Users/Users.vue'
import UserAdd from 'src/components/Dashboard/Views/Settings/Users/UserAdd.vue'
import UserEdit from 'src/components/Dashboard/Views/Settings/Users/UserEdit.vue'
import Feedback from 'src/components/Dashboard/Views/Settings/Feedback/Feedback.vue'
import FeedbackView from 'src/components/Dashboard/Views/Settings/Feedback/FeedbackView.vue'

// Pages
import Login from 'src/components/Dashboard/Views/Pages/Login.vue'
import Register from 'src/components/Dashboard/Views/Pages/Register.vue'
import Recover from 'src/components/Dashboard/Views/Pages/Recover.vue'
import Reset from 'src/components/Dashboard/Views/Pages/Reset.vue'

let loginPage = {
  path: '/login',
  name: 'Login',
  component: Login
}

let registerPage = {
  path: '/register',
  name: 'Register',
  component: Register
}

let recoverPage = {
  path: '/recover',
  name: 'Recover Password',
  component: Recover
}

let resetPage = {
  path: '/reset',
  name: 'Reset Password',
  component: Reset
}

let orderingMenu = {
  path: '/ordering-management',
  component: DashboardLayout,
  children: [
    {
      path: '/',
      name: 'Ordering Management',
      component: OrderingManagement
    },
    {
      path: 'view',
      name: 'Customer Details',
      component: CustomerView
    }
  ]
}

let customersMenu = {
  path: '/customers',
  component: DashboardNoSpacingLayout,
  children: [
    {
      path: '/',
      name: 'Customers',
      component: Customers
    },
    // {
    //   path: 'view',
    //   name: 'Customer Details',
    //   component: CustomerView
    // },
    {
      path: 'view/:id',
      name: 'Customer Details',
      component: Customers
    }
  ]
}

let InfoPage = {
  path: '/info-pages',
  component: DashboardLayout,
  children: [
    {
      path: '/',
      name: 'Info Pages',
      component: InfoPages
    }
  ]
}

let ordersMenu = {
  path: '/orders',
  component: DashboardNoSpacingLayout,
  children: [
    {
      path: '/',
      name: 'Orders',
      component: Orders,
      session: 'newOrders'
    },
    {
      path: 'view/:id',
      name: 'Order Details',
      component: Orders
    },
    {
      path: 'edit/:id',
      name: 'Edit Order',
      component: OrderEdit
    }
  ]
}

let productsMenu = {
  path: '/products',
  component: DashboardNoSpacingLayout,
  children: [
    {
      path: '/products',
      name: 'Products',
      component: Products
    },
    {
      path: '/products/add',
      name: 'Add Product',
      component: Products
    },
    {
      path: '/products/edit/:id',
      name: 'Edit Product',
      component: Products
    }
  ]
}

let prodOptionsMenu = {
  path: '/product-options',
  component: DashboardNoSpacingLayout,
  children: [
    {
      path: '/product-options',
      name: 'Product Options',
      component: ProductOptions
    }
  ]
}

let categoriesMenu = {
  path: '/',
  component: DashboardLayout,
  children: [
    {
      path: '/categories',
      name: 'Categories',
      component: Categories
    },
    {
      path: '/categories/add',
      name: 'Add Category',
      component: CategoryAdd
    },
    {
      path: '/categories/edit/:id',
      name: 'Edit Category',
      component: CategoryEdit
    }
  ]
}

let marketingMenu = {
  path: '/marketing',
  component: DashboardLayout,
  children: [
    {
      path: 'campaigns',
      name: 'Campaigns',
      component: Campaigns
    },
    {
      path: 'campaigns/add',
      name: 'Add Campaign',
      component: CampaignAdd
    },
    {
      path: 'campaigns/edit/:id',
      name: 'Edit Campaign',
      component: CampaignEdit
    },
    {
      path: 'offers',
      name: 'Offers Slider',
      component: Offers
    },
    {
      path: 'offers/add',
      name: 'Add Offer Slider',
      component: OffersAdd
    },
    {
      path: 'offers/edit/:id',
      name: 'Edit Offer Slider',
      component: OffersEdit
    }
  ]
}

let rewardMenu = {
  path: '/',
  component: DashboardLayout,
  children: [
    {
      path: '/reward-program',
      name: 'Edit Reward Program',
      component: RewardProgramEdit
    }
  ]
}

let reportsMenu = {
  path: '/',
  component: DashboardNoSpacingLayout,
  children: [
    {
      path: '/reports',
      name: 'Reports',
      component: Reports
    },
    {
      path: '/reports/customer/:id',
      name: 'Customer Details',
      component: ReportsCustomerDetails
    }
  ]
}

let settingsMenu = {
  path: '/settings',
  component: DashboardNoSpacingLayout,
  children: [
    {
      path: '/',
      name: 'Settings',
      component: Settings
    },
    {
      path: '/users',
      name: 'Users',
      component: Users
    },
    {
      path: '/user/add',
      name: 'Add User',
      component: UserAdd
    },
    {
      path: '/user/edit/:id',
      name: 'Edit User',
      component: UserEdit
    },
    {
      path: '/feedback',
      name: 'Feedback',
      component: Feedback,
      session: 'newFeedback'
    },
    {
      path: '/feedback/view/:id',
      name: 'View Feedback',
      component: FeedbackView
    }
  ]
}

const routes = [
  {
    path: '/',
    component: DashboardNoSpacingLayout,
    redirect: '/admin/overview',
    children: []
  },
  orderingMenu,
  customersMenu,
  InfoPage,
  ordersMenu,
  productsMenu,
  prodOptionsMenu,
  categoriesMenu,
  marketingMenu,
  rewardMenu,
  reportsMenu,
  settingsMenu,
  loginPage,
  registerPage,
  recoverPage,
  resetPage,
  {
    path: '/admin',
    component: DashboardNoSpacingLayout,
    redirect: '/admin/overview',
    children: [
      {
        path: 'overview',
        name: 'Overview',
        component: Overview
      },
      {
        path: 'stats',
        name: 'Stats',
        component: Stats
      }
    ]
  },
  {path: '*', component: NotFound}
]

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
 function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js